// Provider-agnostic billing: checkout, cancel, customer portal.

import { call } from './core';
import type { CheckoutResult } from './types';

export const billingApi = {
  // Billing — provider-agnostic. `refund_policy_agreed` (STA-128, STA-136)
  // mirrors the Pricing page checkbox; the server rejects ``false``.
  checkout: (
    provider?: 'newebpay' | 'stripe',
    return_url?: string,
    refund_policy_agreed: boolean = false,
  ) =>
    call<CheckoutResult>('/billing/checkout', {
      method: 'POST',
      body: JSON.stringify({ provider, return_url, refund_policy_agreed }),
    }),

  cancelSubscription: () =>
    call<{ cancels_at: string }>('/billing/cancel', { method: 'POST' }),

  openPortal: (return_url: string) =>
    call<{ portal_url: string }>('/billing/portal', {
      method: 'POST',
      body: JSON.stringify({ return_url }),
    }),
};
